module.exports = "<footer class=\"footer \">\n\n</footer>\n"